// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Override global button styles for all Ant Design buttons */
.ant-btn {
    background-color: #ffffff !important;
}

/* Primary buttons */
.ant-btn-primary {
    background-color: #1890ff !important;
    color: #ffffff !important;
}

/* Ghost buttons */
.ant-btn-ghost {
    background-color: transparent !important;
}

/* Danger buttons */
.ant-btn-dangerous {
    color: #ff4d4f !important;
    border-color: #ff4d4f !important;
}

/* Hover states */
.ant-btn-primary:hover {
    background-color: #40a9ff !important;
}

.ant-btn-dangerous:hover {
    background-color: #fff1f0 !important;
}

button[type="button"][role="switch"] {
    -webkit-appearance: none;
    background-color: #f0f0f0 !important;
    background-image: none;
    border: none;
}

button[type="button"][role="switch"][aria-checked="true"] {
    background-color: #1890ff !important;
    /* Ant Design's primary color */
}`, "",{"version":3,"sources":["webpack://./src/components/styles.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;IACI,oCAAoC;AACxC;;AAEA,oBAAoB;AACpB;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,wCAAwC;AAC5C;;AAEA,mBAAmB;AACnB;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA,iBAAiB;AACjB;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,wBAAwB;IACxB,oCAAoC;IACpC,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,+BAA+B;AACnC","sourcesContent":["/* Override global button styles for all Ant Design buttons */\n.ant-btn {\n    background-color: #ffffff !important;\n}\n\n/* Primary buttons */\n.ant-btn-primary {\n    background-color: #1890ff !important;\n    color: #ffffff !important;\n}\n\n/* Ghost buttons */\n.ant-btn-ghost {\n    background-color: transparent !important;\n}\n\n/* Danger buttons */\n.ant-btn-dangerous {\n    color: #ff4d4f !important;\n    border-color: #ff4d4f !important;\n}\n\n/* Hover states */\n.ant-btn-primary:hover {\n    background-color: #40a9ff !important;\n}\n\n.ant-btn-dangerous:hover {\n    background-color: #fff1f0 !important;\n}\n\nbutton[type=\"button\"][role=\"switch\"] {\n    -webkit-appearance: none;\n    background-color: #f0f0f0 !important;\n    background-image: none;\n    border: none;\n}\n\nbutton[type=\"button\"][role=\"switch\"][aria-checked=\"true\"] {\n    background-color: #1890ff !important;\n    /* Ant Design's primary color */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
